

/**
 *
 * @class LocomotiveDataHandle
 *
 * The summary of locomotive results for a specific locomotive model in BigQuery.  Will look like this:
 *
 *   {
 *     "read": "/rest/api/1/model/locomotive_forecast_details/table?dataset_id=smartnetwork:betty_white_329d3c5e9dab401b8b22d9b1fcb48f38_LocomotiveModel",
 *     "calculate": "/rest/api/1/model/calculate?dataset_id=smartnetwork:betty_white_329d3c5e9dab401b8b22d9b1fcb48f38_LocomotiveModel",
 *     "update": "/rest/api/1/model/update?dataset_id=smartnetwork:betty_white_329d3c5e9dab401b8b22d9b1fcb48f38_LocomotiveModel",
 *     "delete": "/rest/api/1/model?dataset_id=smartnetwork:betty_white_329d3c5e9dab401b8b22d9b1fcb48f38_LocomotiveModel",
 *     "limit": 20,
 *     "offset": 0,
 *     "query": "SELECT * FROM `smartnetwork:betty_white_329d3c5e9dab401b8b22d9b1fcb48f38_LocomotiveModel.locomotive_forecast_details` ORDER BY ID ASC LIMIT 20 OFFSET 0;",
 *     "tag": []
 *   }
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class LocomotiveDataHandle {

  public id:        string   = '';
  public read:      string   = '';
  public calculate: string   = '';
  public update:    string   = '';
  public delete:    string   = '';
  public limit:     number   = 20;
  public offset:    number   = 0;
  public query:     string   = '';
  public tags:      string[] = [];
  public total:     number   = 0;
  public forecast:  string   = '';
  public created:   string   = '';
  public kind:      string   = '';
  public userid:    string   = '';
  public schema:    any[]    = [];
  public start:     string   = '';
  public end:       string   = '';

  /** standard constructor */
  public constructor(init?: Partial<LocomotiveDataHandle>) {

    Object.assign(this, init);
  }


}
